// const API_URL = "http://localhost:8000/";
const API_URL = "https://api.v2.curatr.app/";

function apiGetRequest(url, params = "", authenticated = false, authToken = "") {
  var headers = {
    "Content-Type": "application/json"
  }
  if (authenticated) {
    headers["Authorization"] = "Token " + authToken
  }
  return new Promise(function(resolve, reject) {
    fetch(API_URL + url, {
      method: "get",
      headers: headers
    })
    .then((response) => {
      response.json().then((data) => {
        if (response.ok) {
          resolve(data);
        } else {
          reject(data)
        }
      })
    })
    .catch((error) => {
      reject(error)
    })
  });
}

function apiPostRequest(url, data, authenticated = false, authToken = "") {
  var headers = {
    "Content-Type": "application/json"
  }
  if (authenticated) {
    headers["Authorization"] = "Token " + authToken
  }
  return new Promise(function(resolve, reject) {
    fetch(API_URL + url, {
      method: "post",
      headers: headers,
      body: JSON.stringify(data)
    })
    .then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          resolve(data);
        });
      } else {
        //reject(data);
        response.json().then((data) => {
          reject(data);
        });
      }
    })
    .catch((error) => {
      reject(error)
    })
  });
}

function apiPutRequest(url, data, authenticated = false, authToken = "") {
  var headers = {
    "Content-Type": "application/json"
  }
  if (authenticated) {
    headers["Authorization"] = "Token " + authToken
  }
  return new Promise(function(resolve, reject) {
    fetch(API_URL + url, {
      method: "put",
      headers: headers,
      body: JSON.stringify(data)
    })
    .then((response) => {
      response.json().then((data) => {
        if (response.ok) {
          resolve(data);
        } else {
          reject(data)
        }
      })
    })
    .catch((error) => {
      reject(error)
    })
  });
}

function apiDeleteRequest(url, data, authenticated = false, authToken = "") {
  var headers = {
    "Content-Type": "application/json"
  }
  if (authenticated) {
    headers["Authorization"] = "Token " + authToken
  }
  return new Promise(function(resolve, reject) {
    fetch(API_URL + url, {
      method: "delete",
      headers: headers,
      body: JSON.stringify(data)
    })
    .then((response) => {
      response.json().then((data) => {
        if (response.ok) {
          resolve(data);
        } else {
          reject(data)
        }
      })
    })
    .catch((error) => {
      reject(error)
    })
  });
}

export {apiPutRequest, apiPostRequest, apiGetRequest, apiDeleteRequest, API_URL};



// WEBPACK FOOTER //
// ./components/utils/api.js